import { dew as _parseAccountDew } from "../../accounts/utils/parseAccount.js";
import { dew as _accountDew } from "../../errors/account.js";
import { dew as _isHexDew } from "../../utils/data/isHex.js";
import { dew as _stringifyDew } from "../../utils/stringify.js";
import { dew as _typedDataDew } from "../../utils/typedData.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.signTypedData = void 0;
  const parseAccount_js_1 = _parseAccountDew();
  const account_js_1 = _accountDew();
  const isHex_js_1 = _isHexDew();
  const stringify_js_1 = _stringifyDew();
  const typedData_js_1 = _typedDataDew();
  async function signTypedData(client, {
    account: account_ = client.account,
    domain,
    message,
    primaryType,
    types: types_
  }) {
    if (!account_) throw new account_js_1.AccountNotFoundError({
      docsPath: "/docs/actions/wallet/signTypedData"
    });
    const account = (0, parseAccount_js_1.parseAccount)(account_);
    const types = {
      EIP712Domain: (0, typedData_js_1.getTypesForEIP712Domain)({
        domain
      }),
      ...types_
    };
    (0, typedData_js_1.validateTypedData)({
      domain,
      message,
      primaryType,
      types
    });
    if (account.type === "local") return account.signTypedData({
      domain,
      primaryType,
      types,
      message
    });
    const typedData = (0, stringify_js_1.stringify)({
      domain: domain ?? {},
      primaryType,
      types,
      message
    }, (_, value) => (0, isHex_js_1.isHex)(value) ? value.toLowerCase() : value);
    return client.request({
      method: "eth_signTypedData_v4",
      params: [account.address, typedData]
    });
  }
  exports.signTypedData = signTypedData;
  //# sourceMappingURL=signTypedData.js.map
  return exports;
}